import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';

export function NoAccessRoute() {
  return (
    <PageContainer width="narrow">
      <PageHeader
        eyebrow="Sin acceso"
        title="Sin condominios asignados"
        subtitle="No tienes acceso a ningún condominio en este momento. Contacta al administrador de tu propiedad o a soporte."
      />
    </PageContainer>
  );
}
